import styled from 'styled-components';
import ProgressBar from '@womcorp/wom-miwom-ui-kit/dist/components/ProgressBar';

const AdsBackgroundStyled = styled.main`
  align-items: center;
  background: linear-gradient(
    180deg,
    #3d016e 0.15%,
    #8634eb 50.64%,
    #ffffff 90.18%
  );
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  justify-content: center;
`;

const ImageStyled = styled.img`
  border-radius: 22px;
  margin-top: 18px;
`;

const DescriptionStyled = styled.div`
  color: #4d008c;
  font-size: 12px;
  line-height: 16px;
  margin-top: 24px;
  @media (min-width: 769px) {
    margin-top: 33px;
  }
`;

const ProgressBarStyled = styled(ProgressBar)`
  && {
    margin: 16px auto 40px;
    width: 296px;
    @media (min-width: 769px) {
      margin: 24px auto 40px;
      width: 480px;
    }
  }
`;

export {
  AdsBackgroundStyled,
  ImageStyled,
  DescriptionStyled,
  ProgressBarStyled,
};
